import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Egitimlerimiz from "../pages/egitimlerimiz/page";
import Hakkimizda from "../pages/hakkimizda/page";
import Iletisim from "../pages/iletisim/page";
import SSS from "../pages/sss/page";
import AdminPanel from "../pages/admin/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/egitimlerimiz",
    element: <Egitimlerimiz />,
  },
  {
    path: "/hakkimizda", 
    element: <Hakkimizda />,
  },
  {
    path: "/kurumsal",
    element: <NotFound />,
  },
  {
    path: "/sss",
    element: <SSS />,
  },
  {
    path: "/iletisim",
    element: <Iletisim />,
  },
  {
    path: "/admin",
    element: <AdminPanel />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;